export default __webpack_public_path__ + "static/media/tesla-logo-white.5ffe3ef8.png";